import { render, staticRenderFns } from "./NewPackage.vue?vue&type=template&id=101250a5"
import script from "./NewPackage.vue?vue&type=script&lang=js"
export * from "./NewPackage.vue?vue&type=script&lang=js"
import style0 from "./NewPackage.vue?vue&type=style&index=0&id=101250a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports